import { InputLabel, TextField, Typography } from '@mui/material';
import { getIn } from 'formik';
import React from 'react';

export interface FormikTextInputProps {
  // Formik fields, inherited from FastField / Field
  field: {
    value: string | number;
    name: string;
    onChange: () => void;
    onBlur: () => void;
  };
  form: {
    errors: Record<string, string>;
    touched: Record<string, boolean>;
    submitCount: number;
  };

  // Custom onChange overrride, if needed
  onChange?: (
    ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;

  label: string;

  // Optional input properties
  rows?: number;
  disabled?: boolean;
  multiline?: boolean;
  placeholder?: string;
  type?: string;

  // Optional styling / override
  variant?: 'filled' | 'standard' | 'outlined' | undefined;
  required?: boolean;
}

export const FormikTextInput = (props: FormikTextInputProps) => {
  const {
    field: { name, value, onChange, onBlur },
    form: { touched, errors, submitCount },
    onChange: customOnChange,
    label,
    rows,
    multiline = false,
    disabled = false,
    placeholder,
    type,
    variant = 'outlined',
  } = props;

  const hasErrorWithoutTouch = submitCount > 0;
  const touchedOrSubmitted = getIn(touched, name) || hasErrorWithoutTouch;
  const hasError = Boolean(touchedOrSubmitted && getIn(errors, name));

  return (
    <>
      <InputLabel sx={{ paddingTop: 2 }} error={hasError} htmlFor={name}>
        <Typography variant="caption" sx={{ marginBottom: 1 }}>
          {label}
          {props.required && <Typography
            variant="caption"
            component="span"
            sx={{ paddingLeft: '2px', color: '#c62828' }}
          >
            *
          </Typography>}
        </Typography>
      </InputLabel>
      <TextField
        variant={variant}
        fullWidth
        id={name}
        name={name}
        type={type}
        value={value}
        onChange={customOnChange ? customOnChange : onChange}
        onBlur={onBlur}
        error={hasError}
        helperText={touchedOrSubmitted && getIn(errors, name)}
        rows={rows}
        disabled={disabled}
        multiline={multiline}
        placeholder={placeholder}
        // disables scrolling (https://github.com/mui-org/material-ui/issues/7960)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onWheel={(event) => (event.target as any).blur()}
      />
    </>
  );
};
